import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ---------- Frontend error logger (Phase 9 pivot) ----------
// Cattura errori JS globali e li invia al backend in `diag_events`. Utile per
// diagnosticare pagine rotte solo in prod (script injectati, race conditions,
// bundle stale). Best-effort: fallimenti del logger stesso sono ignorati per
// non creare loop di errore.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const reportedRecently = new Set();  // dedup finestra breve

function sendFrontendError(payload) {
    try {
        // Dedup: stessa stringa message+stack in 2s → skip (evita flood)
        const key = (payload.message || "") + "|" + (payload.stack || "").slice(0, 120);
        if (reportedRecently.has(key)) return;
        reportedRecently.add(key);
        setTimeout(() => reportedRecently.delete(key), 2000);

        const body = JSON.stringify({
            message: String(payload.message || "").slice(0, 1000),
            stack: String(payload.stack || "").slice(0, 5000),
            url: String(payload.url || window.location.href || "").slice(0, 500),
            user_agent: String(navigator.userAgent || "").slice(0, 500),
        });
        // Uso fetch keepalive per non perdere il beacon anche al page unload.
        fetch(`${BACKEND}/api/diag/frontend-error`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body,
            keepalive: true,
            credentials: "omit",
        }).catch(() => {});
    } catch (_) {
        // Silent: il logger non deve mai lanciare
    }
}

window.addEventListener("error", (ev) => {
    sendFrontendError({
        message: ev.message || (ev.error && ev.error.message) || "window.error",
        stack: ev.error && ev.error.stack ? ev.error.stack : "",
        url: window.location.href,
    });
});

window.addEventListener("unhandledrejection", (ev) => {
    const reason = ev.reason;
    sendFrontendError({
        message: (reason && (reason.message || String(reason))) || "unhandledrejection",
        stack: reason && reason.stack ? reason.stack : "",
        url: window.location.href,
    });
});

// Espone in window per testing (usato dai test agent)
window.__reportFrontendError = sendFrontendError;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
